import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

// Auvers badges: pill shape, label-caps typography, tonal ink/paper variants.
// Status reads tonally — gold marks the single accent, red/green/blue are off-limits.
const badgeVariants = cva(
  "inline-flex items-center rounded-pill border px-2.5 py-1 font-sans text-[11px] font-medium uppercase tracking-[0.06em] transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-rule bg-paper-3 text-ink",
        secondary:
          "border-rule bg-paper-2 text-ink-soft",
        destructive:
          "border-[#c19388] bg-[#f5e3df] text-[#7a3325]",
        outline:
          "border-rule bg-transparent text-ink",
        success:
          "border-rule bg-paper-3 text-ink",
        warning:
          "border-gold-soft bg-[#fbf3dd] text-[#6e5320]",
        error:
          "border-[#c19388] bg-[#f5e3df] text-[#7a3325]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
